import { Injectable } from "@angular/core";
import { Configuration } from "./configuration";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  public configuration: Configuration;

  constructor() {
    this.configuration = {
      apis: {
        auth: "/Authenticate",
        logging: "",
        account: {
          base: "/Account",
          addUser: "/Users/Add", // hTTPPost
          deleteUser: "/Users/Delete/", // hTTPGet + {id}
          get: "/Users/", // hTTPGet + {id}
          addtoRole: "/Roles/AddTo", // hTTPPost
          getAll: "/Users/All", // hTPPGet
        },
      },
      serverLogging: {
        exception: true,
        warning: true,
        debug: false,
      },
      animatedNavigationTimeout: 700,
    };
  }
}
